<template>
  <transition name="fade">
    <Loader v-if="!$beet.isReady" />
  </transition>

  <template v-if="$beet.isReady">
    <SiteNav />

    <router-view v-slot="{ Component }">
      <transition name="fade-fast" mode="out-in">
        <component :is="Component" :key="$route.path" />
      </transition>
    </router-view>
    <Gdpr :options="{ backgroundColor: '#20211e', color: '#fff' }" />
    <Footer />
  </template>
</template>

<script>
import Gdpr from '@/components/gdpr/Gdpr.vue'
import Footer from '@/components/sections/Footer.vue'
import SiteNav from '@/components/SiteNav.vue'
import Loader from '@/components/small/Loader.vue'
import { useLangRouter } from '@/extensions/langRouter'

export default {
  name: 'App',
  setup() {
    useLangRouter()
  },
  components: { Gdpr, Footer, Loader, SiteNav },
  mounted() {
    setTimeout(() => {
      if (this.$route.hash)
        this.$nextTick(() => {
          document
            .getElementById(this.$route.hash.replace('#', ''))
            ?.scrollIntoView({ behavior: 'smooth' })
        })
    }, 1500)
  },
  watch: {
    '$i18n.locale': {
      handler: function (to) {
        this.$beet.fetchCoreData(to)
      },
      immediate: true,
    },
  },
}
</script>
